import { useQueryClient } from 'react-query';

import {
  MERCURE_MESSAGE_TYPE_ORDER,
  useMercureContext,
} from '@/common/contexts/MercureContext/MercureContext';
import useMercureMessageSubscriber from '@/common/contexts/MercureContext/useMercureMessageSubscriber';

const useOrdersSubscription = (queryKey) => {
  const { userTopic } = useMercureContext();
  const queryClient = useQueryClient();

  const handleSubscribe = (newOrder) => {
    const data = queryClient.getQueryData(queryKey);
    const orderIndex =
      data?.data?.reduce(
        (accu, item, i) => (newOrder?.payload?.id === item.id ? i : accu),
        -1,
      ) ?? -1;
    if (orderIndex !== -1) {
      queryClient.setQueryData(queryKey, (existingData) => {
        if (!existingData) return existingData;
        return {
          ...existingData,
          data: [
            ...existingData.data.map((order, index) =>
              index === orderIndex ? newOrder.payload : order,
            ),
          ],
        };
      });
    }
  };

  useMercureMessageSubscriber(
    userTopic,
    MERCURE_MESSAGE_TYPE_ORDER,
    handleSubscribe,
  );
};

export default useOrdersSubscription;
